<div class="modal-content">
  <div class="modal-header">
    <h4 class="title is-size-4" translate="sustainability.info.title"></h4>
  </div>
  <div class="modal-body">
    <p class="has-text-grey mb-4" translate="sustainability.info.subtitle"></p>

    <app-please-be-patient></app-please-be-patient>

    <div [formGroup]="form" novalidate>
      <div class="field">
        <fino-input
          formControlName="link"
          label="sustainability.label"
          inputAutocompleteOff
          validationIndicator
        >
          <div
            class="is-fullheight is-flex is-justify-content-center is-align-items-center ml-4"
            input-right
          >
            <fino-switch
              formControlName="isActive"
              [hideLabel]="true"
            ></fino-switch>
          </div>
        </fino-input>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="is-flex is-centered mt-4">
      <button
        [primary]="true"
        type="button"
        class="has-text-weight-bold mr-1"
        [disabled]="formNotTouched"
        (click)="submit()"
        fino-button
        label="sustainability.submit"
      ></button>

      <button
        type="button"
        (click)="abort()"
        class="ml-1"
        fino-button
        label="sustainability.abort"
      ></button>
    </div>
  </div>
</div>
